module.exports = __webpack_public_path__ + "images/picto-fans-home.png?28260";